import dayjs from '@/utils/dayjs.config';

export interface FormatDateIfValidOptions<F> {
  formatTemplate: string;
  fallbackValue: F;
}

export const formatDateIfValid = <F = null>(
  date: Date | string | null,
  { fallbackValue, formatTemplate }: FormatDateIfValidOptions<F>,
) => {
  const dateObj = dayjs(date);
  if (!dateObj.isValid()) {
    return fallbackValue;
  }

  const formattedValue = dateObj.format(formatTemplate);
  return formattedValue;
};
